<template>
 <svg :style="style"  width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Mask group">
<mask id="mask0_3735_78491" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
<rect id="Rectangle 34624921" width="32" height="32" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_3735_78491)">
</g>
<g id="Frame">
<path id="Vector" d="M24.735 11.616C23.343 8.176 22.511 4.624 22.383 0.703997C22.383 0.271997 22.143 0.0479972 21.871 0.0159972H21.791H10.207H10.175C9.887 -2.83663e-06 9.599 0.223997 9.599 0.703997C9.471 4.624 8.639 8.24 7.247 11.616C5.807 15.168 6.767 17.76 9.599 18.784C12.431 19.808 14.607 18.064 14.783 16.128C14.911 14.624 15.263 13.776 15.983 13.712C16.703 13.776 17.071 14.624 17.183 16.128C17.359 18.112 19.535 19.872 22.367 18.784C25.215 17.76 26.175 15.168 24.735 11.616Z" fill="white"/>
<path id="Vector_2" d="M24.1917 18.304C22.7517 21.072 17.9197 19.936 17.4397 18.304C17.1997 17.392 16.8317 16.976 15.9997 16.912C15.2157 16.976 14.7997 17.456 14.5597 18.304C14.0797 19.936 9.24767 21.072 7.87167 18.368C7.02367 16.8 4.55967 17.216 4.67167 19.328C4.91167 23.728 6.11166 26.448 8.83166 27.952C9.74366 28.432 10.1597 29.648 10.4637 31.328C10.5277 31.696 10.7357 31.904 10.9597 31.968C11.0717 32 11.1837 32 11.2957 31.968H21.0077C21.2637 31.936 21.5037 31.728 21.5837 31.328C21.8877 29.632 22.3677 28.432 23.2157 27.952C25.9357 26.448 27.1357 23.728 27.4397 19.264C27.5037 17.216 24.9757 16.8 24.1917 18.304ZM26.1117 19.216C25.9357 22.96 25.1997 25.184 22.7997 26.816C21.5037 27.728 20.7837 28.464 20.3997 30.768H11.5837C11.1997 28.464 10.4317 27.68 9.18367 26.816C6.76767 25.184 6.04767 22.96 5.87167 19.216C5.80767 18.608 6.47966 18.432 6.71966 18.912C7.50366 20.176 8.76766 21.136 10.7677 21.2C13.7757 21.264 15.4717 19.936 15.7757 18.432C15.7757 18.304 15.8397 18.192 16.0157 18.192C16.1917 18.192 16.2557 18.256 16.2557 18.432C16.5597 20 18.2397 21.264 21.2637 21.2C23.2477 21.2 24.5277 20.24 25.3117 18.912C25.5197 18.432 26.1757 18.544 26.1117 19.216Z" fill="white"/>
</g>
</g>
</svg>




</template>

<script>
export default {
  name: 'icon-gzl',
  props: {
    fontSize: {
      type: String,
      default: '18px'
    },
    color: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      style: {
        width: '1em',
        height: '1em',
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        cursor: 'pointer',
        'font-size': this.fontSize
      }
    }
  }
}
</script>